const callAsync = Promise.resolve().then.bind(Promise.resolve());
export default callAsync;
